export const selectAuthenticated = state => state.authentication.authenticated

export const selectAccessToken = state => state.authentication.accessToken

export const selectRefreshToken = state => state.authentication.refreshToken

export const selectAccessType = state => state.authentication.accessType

export const selectUser = state => state.authentication.user

export const selectUserId = state => state.authentication.user.id

export const selectUserProfile = state => state.authentication.user.profile

export const selectUserContext = state => state.authentication.user.profiles?.context

export const selectUserApplications = state => state.authentication.userApplications

export const selectUserCompany = state => state.authentication.user.companies

export const selectCurrentUserDefaultProperty = state => state.authentication.user?.farmPropertyDefault

export const selectCurrentUserProperties = state => state.authentication.user?.farmPropertiesAccess

export const selectAuthError = state => state.authentication.error
